<div *ngIf="template$ | async" class="grid-max-width grid-col-12">
  <div class="col-1-12">
    <fin-cms-json-content [template$]="template$"></fin-cms-json-content>
    <fin-timetable-search></fin-timetable-search>
  </div>
  <div class="col-1-12" *ngIf="(noSearchResults$ | async) && !(data$ | finMap: 'availability' | async)?.length">
    <cms-unstyled-fragment
      [contentUrl$]="'fragments.timetables.noSearchResults.url' | finLocalization | finToObservable"
    >
    </cms-unstyled-fragment>
  </div>
  <div class="col-1-12" *ngIf="(data$ | finMap: 'availability' | async)?.length">
    <fin-seasonal-notification
      [origin]="search$ | finMap: 'origin.title' | async"
      [destination]="search$ | finMap: 'destination.title' | async"
      [availability]="data$ | finMap: 'availability' | async"
    >
    </fin-seasonal-notification>
  </div>
  <div
    class="col-1-12 nordic-blue-900-text font-body-1"
    *ngIf="hasInitialLoadCompleted"
    data-testid="timetable-origin-destination-title"
  >
    {{ search$ | finMap: 'origin.title' | async }} ({{ search$ | finMap: 'origin.code' | async }}) -
    {{ search$ | finMap: 'destination.title' | async }} ({{ search$ | finMap: 'destination.code' | async }})
  </div>
  <div class="col-1-12">
    <div class="flex calendar-schedule-wrapper">
      <div class="flex-1 flex--basis0 ms-small-r pr-medium-b relative">
        <fin-timetable-calendar></fin-timetable-calendar>
      </div>
      <div class="flex-1 flex--basis0 ms-small-l">
        <fin-timetable-schedule></fin-timetable-schedule>
      </div>
    </div>
  </div>
</div>

<cms-full-width-booking-widget
  *ngIf="(template$ | async) && (showBookingWidget$ | async)"
  [enableAward]="true"
  [enableAurinkomatkat]="false"
  [enablePromoCode]="true"
  [locations]="locations$ | async"
  [backgroundImage]="backgroundImage$ | async"
  [enableAutoFocus]="false"
>
</cms-full-width-booking-widget>

<ng-container *ngIf="enablePageFeedback">
  <fin-qualtrics-embedded-page-feedback [pageType]="'full'"></fin-qualtrics-embedded-page-feedback>
</ng-container>
